import { makeAutoObservable } from 'mobx'
import { type Integration } from 'entities/Integrations'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { IntegrationCollapseSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationCollapseSettingsStore'
import { IntegrationSettingsUsersStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsUsersStore'

export class IntegrationCalendlySettingsStore {
  private _collapseStore
  private _userStore

  constructor(integration: Integration, private _entities: IEntitiesStore) {
    this._collapseStore = new IntegrationCollapseSettingsStore()
    this._userStore = new IntegrationSettingsUsersStore(integration, this._entities)

    makeAutoObservable(this)
  }

  init = () => {
    this._userStore.init()
  }

  get userStore() {
    return this._userStore
  }

  get collapseStore() {
    return this._collapseStore
  }
}
